import { Grid } from '@mui/material';

import { QuoteListProps } from '../quoteTypes';
import QuoteCard from './QuoteCard';
import QuoteEmptyResults from './QuoteEmptyResults';

function QuoteCardList({ isLoading, rows, hasRoles, backOfficeRootUrl }: QuoteListProps) {
  return (
    <>
      <Grid container sx={{ px: 2, pt: 2, pb: 3 }}>
        {rows.map((row, index) => (
          <Grid key={`QuoteRow_${index}`} item xs={12} md={6}>
            <QuoteCard row={row} key={`Quote_${index}`} backOfficeRootUrl={backOfficeRootUrl} />
          </Grid>
        ))}
      </Grid>
      <QuoteEmptyResults
        sx={{ paddingBottom: 5, paddingLeft: 3, paddingRight: 3 }}
        hasRoles={hasRoles}
        hasRows={rows.length > 0}
        isLoading={isLoading}
      />
    </>
  );
}

export default QuoteCardList;
